module.exports = __webpack_public_path__ + "static/actionShot-20528f636eb1dd90b7d15354f067e522.jpg";